import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { config } from '../../shared/config';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private api: ApiService = inject(ApiService);
  private http: HttpClient = inject(HttpClient);

  /**
   * Verify the email address.
   */
  checkEmail(): Observable<any> {
    return this.api.getAnySingle('verify');
  }

  /**
   * Resend the account verification email.
   * used to resend or change the email address of the guardian
   */
  verifyEmail(email: string): Observable<any> {
    const params = new HttpParams({ fromObject: { EmailAddress: email } });

    return this.http.post(
      `${config.baseApiUrl}/api/verify/ResendAccountVerification`,
      {},
      { headers: this.api.getHeaders(), params }
    );
  }

  verify(code: string): Observable<any> {
    let headers = this.api.getHeaders();
    headers = headers.append('X-Fortress-ActivationKey', code);
    return this.http.post(`${config.baseApiUrl}/api/verify/verifier`, {}, { headers });
  }
}
